import { Component, ViewChild, Input, Output, EventEmitter,  OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { PagePreloaderComponent } from '../../shared/ui';
import { TransferProduct, Transfer, TransferDelete } from '../shared';
import { TransferDetailService } from './transfer-detail.service';

@Component({
  selector: 'transfer-detail',
  styles: [require('./transfer-detail.component.scss')],
  template: require('./transfer-detail.component.pug')
})
export class TransferDetailComponent implements OnInit {
     @ViewChild(PagePreloaderComponent) preloader;

     @Input() transfer: Transfer = <Transfer>{};
     @Output() applyDeleteTransferSucess = new EventEmitter();

    products$: Observable<TransferProduct[]>;
    transferDelete = new TransferDelete();
    deleteAlert: boolean = false;
    errorMessage: string = 'Error';
    error: boolean = false;

    private _preloaderSubs: Subscription;

    constructor(private _transferDetailService: TransferDetailService) {}

    ngOnInit() {
        
        if (this.transfer && this.transfer.id) {
            this.transferDelete.addTransferToDelete(this.transfer.id);
            
            this.products$ =  this._transferDetailService.getTransferProducts(this.transfer.id);
            this._preloaderSubs = this.products$.subscribe(res => {
                    this.preloader.hide();
            });
        }else {
             this.preloader.hide();
        }
    }

    beginDelete() {
        this.deleteAlert = true;
    }

    cancel() {
        this.error = false;
        this.deleteAlert = false;
    }

    deleteTransfer(e: MouseEvent) {
        e.preventDefault();
        this.preloader.show();
        this.error = false;
        this._transferDetailService.deleteTransfer(this.transferDelete)
                                    .subscribe(res => {
                                        this.preloader.hide();
                                        this.applyDeleteTransferSucess.emit();
                                    },
                                    error => {
                                        this.preloader.hide();
                                        this.error = true;
                                        this.errorMessage = error.statusText
                                                                ? error.statusText
                                                                : 'Error deleting. Try again.';
                                    });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/transfer-detail/transfer-detail.component.ts